import { __decorate } from "tslib";
import { theme } from '@dojo/framework/core/mixins/Themed';
import { v, w } from '@dojo/framework/core/vdom';
import { ScoreRollup } from '../../support/score-rollup';
import { QuestionQueue } from '../../support/questionqueue';
import { QFAuditBase } from './auditbase';
import css from '../../css/questionfeedback.m.css';
let PosttestQuestionFeedback = class PosttestQuestionFeedback extends QFAuditBase {
    render_page() {
        const { isPlaceholder } = this.properties.localizedBundle;
        if (isPlaceholder) {
            return [];
        }
        const { isrunning, instancekey = '', quizstore } = this.properties;
        const { finalize, startquiz, svc } = this;
        switch (isrunning) {
            case 'quiz':
                return [
                    w(QuestionQueue, {
                        key: `${instancekey}-queue`,
                        svc,
                        finalize,
                        startquiz,
                        quizstore
                    })
                ];
            case 'audit':
                return this.run_audit();
            case 'final':
                return this.run_quiz_end();
            default:
                return this.run_quiz_begin();
        }
    }
    render() {
        const { quiz, info, key, quizstore } = this.properties;
        const hasdata = quiz && info;
        !hasdata && this.load_quiz();
        return v('div', { key, xqa: `progression posttest question-feedback` }, hasdata
            ? [w(ScoreRollup, { key: `rollup-${key}`, quizstore }, this.render_page())]
            : this.render_loading());
    }
};
PosttestQuestionFeedback = __decorate([
    theme(css)
], PosttestQuestionFeedback);
export { PosttestQuestionFeedback };
